import React from 'react';
import { CmsAsset, CmsPhase } from '../../integrations/contentful/types';
import MemoryPhase from './MemoryPhase';

interface MemoryPhasesProps {
  phases: readonly CmsPhase[];
  onMediaClick?: (media: CmsAsset) => void;
  shipTrip: boolean;
}

const MemoryPhases: React.FunctionComponent<MemoryPhasesProps> = ({
  phases,
  onMediaClick,
  shipTrip
}) => {
  return (
    <div>
      {phases.map((phase, index) => (
        <MemoryPhase
          key={phase.sys.id}
          phase={phase}
          onMediaClick={onMediaClick}
          isFirstPhase={index === 0}
          isLastPhase={index === phases.length - 1}
          shipTrip={shipTrip}
        />
      ))}
    </div>
  );
};

export default MemoryPhases;
